"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseOutlinedStyled = exports.TitleStyled = exports.HideInfoButton = exports.RowStatus = exports.ColStatus = exports.InputStyled = exports.AnimatedText = exports.AnimatedGroup = exports.GridGroup = exports.Group = exports.Building = exports.Container = void 0;
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const styled_components_1 = __importStar(require("styled-components"));
const constants_1 = require("../../../assets/constants/constants");
const Text_1 = __importDefault(require("../../../components/shared/Text"));
const turnRight = (0, styled_components_1.keyframes) `
  from {
    transform: rotate(0)
  }
  to {
    transform: rotate(45deg)
  }
`;
const turnLeft = (0, styled_components_1.keyframes) `
  from {
    transform: rotate(45deg)
  }
  to {
    transform: rotate(0deg)
  }
`;
const slideTextOpen = (0, styled_components_1.keyframes) `
  from {
    height: 0px;
    position: relative;
    top: -60px;
    opacity: 0;
  }
  to {
    height: auto;
    position: relative;
    top: 0px;
    opacity: 1;
    z-index: 1;
  }
`;
const slideTextClose = (0, styled_components_1.keyframes) `
  from {
    height: auto;
    position: relative;
    top: 0px;
    opacity: 1;
  }
  to {
    height: 0px;
    position: relative;
    top: -60px;
    opacity: 0;
    z-index: -1;
  }
`;
const slideButton = (0, styled_components_1.keyframes) `
from {
  left:10px;
}
  to {
    left: 100%;
  }
`;
const slideButton2 = (0, styled_components_1.keyframes) `
  to {
    left: -8px;
  }
`;
exports.Container = styled_components_1.default.div `
  width: 75%;
  margin-left: auto;
  user-select: none;
  background-color: #f6f6f6;
  padding: 10px;
  .anticon {
    height: max-content;
    margin: 0 4px;
    svg {
      width: 16px;
      display: flex;
    }
  }
  .ant-row-space-between {
    align-items: center;
  }
  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`;
exports.Building = styled_components_1.default.div `
  display: flex;
  div:first-child {
    width: 123px;
    height: 145px;
    margin-right: 5px;
    img {
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
      width: 100%;
    }
  }
  div:last-child {
    display: flex;
    flex-direction: column;
  }
  .checkAmenities {
    cursor: pointer;
    text-decoration: underline;
    margin-top: 20px;
  }
`;
exports.Group = styled_components_1.default.div `
  display: ${props => (!props.status ? 'flex' : 'none')};
  justify-content: space-between;
  margin: 5px 0;
  align-items: center;
  ${props => props.disabled &&
    (0, styled_components_1.css) `
      pointer-events: none;
      opacity: 0.4;
    `}
`;
exports.GridGroup = styled_components_1.default.form `
  align-items: center;
  justify-content: center;
  display: grid;
  grid-template-columns: 70% 28%;
  width: 100%;
  justify-content: space-between;
  button {
    width: 100%;
    height: 95%;
  }
`;
exports.AnimatedGroup = (0, styled_components_1.default)(exports.Group) `
  animation: ${props => {
    if (props.active) {
        return slideTextOpen;
    }
    if (props.visibility) {
        return slideTextClose;
    }
    return null;
}}
    0.2s linear forwards;

  flex-direction: column;
  position: relative;
  ${props => !props.visibility &&
    (0, styled_components_1.css) `
      visibility: hidden;
      height: 0px;
    `}
`;
exports.AnimatedText = (0, styled_components_1.default)(Text_1.default) `
  color: ${props => props.color || '#000'};
  font-weight: ${props => (props.bold ? '500' : 'normal')};
  font-size: ${props => props.size || 13}px;
  animation: ${props => (props.active ? turnRight : turnLeft)} 0.1s linear forwards;
  cursor: pointer;
`;
exports.InputStyled = (0, styled_components_1.default)(antd_1.Input) `
  height: 42px;
  border-radius: 5px;
  min-height: 43px;
  @media only screen and (max-width: ${constants_1.SCREEN_WIDTH.mobile}px) {
    margin-bottom: 5px;
  }
`;
exports.ColStatus = (0, styled_components_1.default)(antd_1.Col) `
  display: ${props => (props.status ? 'flex' : 'none')};
`;
exports.RowStatus = (0, styled_components_1.default)(antd_1.Row) `
  display: ${props => (props.status ? 'flex' : 'none')};
`;
exports.HideInfoButton = styled_components_1.default.div `
  position: absolute;
  visibility: visible;
  transform: translateY(-50%);
  height: 50px;
  width: 20px;
  text-align: center;
  padding: 0;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 0 5px 5px 0;
  background-color: var(--main-color);
  color: #fff;
  border-left: none;
  top: 45vh;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px 0px rgba(0, 0, 0, 0.14),
    0px 1px 8px 0px rgba(0, 0, 0, 0.12);
  left: -2.5%;
  ${props => props.isOpen
    ? (0, styled_components_1.css) `
          animation: ${slideButton} 0.2s linear forwards;
        `
    : (0, styled_components_1.css) `
          animation: ${slideButton2} 0.2s linear;
        `};
`;
exports.TitleStyled = styled_components_1.default.span `
  font-weight: 500;
  font-size: 34px;
`;
exports.CloseOutlinedStyled = (0, styled_components_1.default)(icons_1.CloseOutlined) `
  color: var(--main-color);
  font-size: 20px;
  line-height: 20px;

  &:hover {
    cursor: pointer;
  }
`;
